import { Box, Caption, TextBlock, TextCell } from "@bcc-ui/ui-components";
import { TFunction } from "i18next";
import * as React from "react";

import style from "./product-name-column.scss";
import TextWithTooltip from "components/table/TextWithTooltip";
import { featureFlagService, FLAG_UICOMPS_WORKFLOWS_TABLE } from "services/feature/FeatureFlagService";
import { EditorGeneration, Profile, profileToNameMap } from "services/workflows/WorkflowService";

const DOT = " • ";
const ProductNameColumn = (props: {
    profile: string;
    version: string;
    generation: EditorGeneration;
    t: TFunction;
}): JSX.Element => {
    const profile = props.profile as Profile;

    const createAdditionalInfoPart = () => {
        if (profile !== Profile.BMDE_DIAGNOSTIC) {
            return;
        }
        const content = profile === Profile.BMDE_DIAGNOSTIC && props.t("WorkflowsTable.diagnosticOnly");
        return DOT + content;
    };

    // TODO BCC-8002: Remove after Workflows table rewrite is complete
    const isWorkflowsTableFeatureEnabled = featureFlagService.isFeatureEnabled(FLAG_UICOMPS_WORKFLOWS_TABLE);

    // TODO BCC-8002: Remove this if block and the related css after Workflows table rewrite is complete
    if (!isWorkflowsTableFeatureEnabled) {
        return (
            <div className={style.contentContainer}>
                <TextWithTooltip
                    text={profileToNameMap.get(
                        props.profile === Profile.BMDE_DIAGNOSTIC ? Profile.BMDE : (props.profile as Profile)
                    )}
                />
                {props.version && (
                    <div className={style.versionContainer}>
                        <span>
                            {props.version} {createAdditionalInfoPart()}{" "}
                        </span>
                    </div>
                )}
            </div>
        );
    }

    return (
        <TextCell>
            <Box columnLayout>
                <Box verticalAlignment="Center" className={style.upperRow}>
                    <TextBlock disableBottomSpacing>
                        {profileToNameMap.get(
                            props.profile === Profile.BMDE_DIAGNOSTIC ? Profile.BMDE : (props.profile as Profile)
                        )}
                    </TextBlock>
                </Box>
                {props.version && (
                    <Caption greyTextStyle>
                        {props.version} {createAdditionalInfoPart()}
                    </Caption>
                )}
            </Box>
        </TextCell>
    );
};

export default ProductNameColumn;
